import { getSession } from "next-auth/react";
import { CookieNameEnum } from "../constants/cookie-names";
import { getCookie } from "cookies-next";

/** Chama o ``next-auth`` atualizando o token do usuário caso necessário. */
export async function getUserToken() {
    await getSession()

    const accessToken = getCookie(CookieNameEnum.UserAccessToken)

    return accessToken
}